import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export interface PurchaseApplicationCancelProps {}

interface LocalSessionData {
  tenantId?: string;
  serviceId?: string;
  customerKind?: string;
}

export const PurchaseApplicationCancel: React.FC<PurchaseApplicationCancelProps> = () => {
  const query = new URLSearchParams(useLocation().search);
  const localSessionDataKey = query.get('sessionDataKey') ?? undefined;
  const navigate = useNavigate();

  React.useEffect(() => {
    const getLocalSessionData = (localSessionDataKey: string) => {
      return JSON.parse(
        window.localStorage.getItem(localSessionDataKey) ?? '{}',
      );
    };

    if (localSessionDataKey) {
      const sessionData: LocalSessionData = getLocalSessionData(
        localSessionDataKey,
      );
      if (sessionData.tenantId && sessionData.serviceId) {
        window.localStorage.removeItem(localSessionDataKey);
        navigate(
          `/application/pjb/purchase?step=1&serviceId=${sessionData.serviceId}&tenantId=${sessionData.tenantId}&customerKind=${sessionData.customerKind}`,
        );
      } else {
        navigate('/');
      }
    }
  }, [localSessionDataKey, navigate]);

  return <></>;
};
